<div class="dialog-overlay">
  <div class="dialog-box">
    <div class="dialog-header">
      <h2 class="dialog-title">{{ data.title }}</h2>
      <button class="close-btn" (click)="onCancel()">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="dialog-body">
      <p class="dialog-message">{{ data.message }}</p>

      <div class="dialog-actions">
        <button class="btn-primary" (click)="onConfirm()">{{ confirmationText() }}</button>
        <button class="btn-cancel" (click)="onCancel()">{{ cancelText() }}</button>
      </div>
    </div>
  </div>
</div>
